import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Helper from "./helper.current_buy_sell";
import {
  modifyDataDrill,
  drillDownModify,
} from "../pages/compare/commonFunctions";
import DrillDown from "../d3Components/drillDownPie/drillDown";
import "./Current_buy_sell.style.scss";
// import table from "./Create/universe_lite/table";
import BuySellTable from "../common/buySellTable";

class CurrentBuySell extends Component {
  state = {
    heading: [
      "ORIGINAL Portfolio",
      "Weight (%)",
      "IQCIO Portfolio",
      "Weight (%)",
      "Recommendation",
    ],
    IQCIO_chart_options_new: [],
    IQCIO_chart_data_new: [],
    tableData: [],
  };

  componentDidMount() {
    const { yourDrilldown, getBenchmark } = this.props;
    // data based on current api call on newly created ID
    if (yourDrilldown && yourDrilldown.length > 0 && getBenchmark) {
      let IQCIO_chart_data_new = modifyDataDrill(getBenchmark.getPortfolioData);
      let IQCIO_chart_options_new = drillDownModify(
        getBenchmark.getPortfolioData
      );

      let tableData = Helper.tableData(yourDrilldown, IQCIO_chart_data_new);
      this.setState({
        tableData,
        IQCIO_chart_data_new,
        IQCIO_chart_options_new,
      });
    }

    // if (
    //   (yourDrilldown && yourDrilldown.length > 0) ||
    //   (iqcioDrilldown && iqcioDrilldown.length > 0)
    // ) {
    //   let tableData = Helper.tableData(yourDrilldown, iqcioDrilldown);
    //   this.setState({
    //     tableData,
    //   });
    // }
  }

  componentWillReceiveProps(nextProps) {
    const { yourDrilldown, getBenchmark } = nextProps;
    // data based on current api call on newly created ID
    console.log(getBenchmark);
    if (yourDrilldown && yourDrilldown.length > 0 && getBenchmark) {
      let IQCIO_chart_data_new = modifyDataDrill(getBenchmark.getPortfolioData);
      let IQCIO_chart_options_new = drillDownModify(
        getBenchmark.getPortfolioData
      );

      let tableData = Helper.tableData(yourDrilldown, IQCIO_chart_data_new);
      this.setState({
        tableData,
        IQCIO_chart_data_new,
        IQCIO_chart_options_new,
      });
    }

    // const { yourDrilldown, iqcioDrilldown } = nextProps;
    // if (
    //   (yourDrilldown && yourDrilldown.length > 0) ||
    //   (iqcioDrilldown && iqcioDrilldown.length > 0)
    // ) {
    //   let tableData = Helper.tableData(yourDrilldown, iqcioDrilldown);
    //   this.setState({
    //     tableData,
    //   });
    // }
  }

  // dataModification = (getBenchmark) => {
  //   if (getBenchmark.getBenchmarkData) {
  //     let date = Helper.getRecentData(getBenchmark.getBenchmarkData);
  //     let filteredBenchmark = getBenchmark.getBenchmarkData.filter(
  //       (e) => e.dt == date
  //     );

  //     let chartData = modifyDataDrill(filteredBenchmark);
  //     let chartOptions = drillDownModify(filteredBenchmark);

  //     this.setState({
  //       yourDrillDown: chartData,
  //       your_chartOptions: chartOptions,
  //     });
  //   }
  //   if (getBenchmark.getPortfolioData) {
  //     let date = Helper.getRecentData(getBenchmark.getPortfolioData);
  //     let filterPortfolioData = getBenchmark.getPortfolioData.filter(
  //       (e) => e.dt == date
  //     );

  //     let chartData = modifyDataDrill(filterPortfolioData);
  //     let chartOptions = drillDownModify(filterPortfolioData);

  //     this.setState({
  //       iqcioDrillDown: chartData,
  //       iqcio_chartOptions: chartOptions,
  //     });
  //   }
  //   if (getBenchmark.getBenchmarkData && getBenchmark.getPortfolioData) {
  //     let tableData = Helper.tableData(
  //       getBenchmark.getBenchmarkData,
  //       getBenchmark.getPortfolioData
  //     );

  //     this.setState({
  //       tableData,
  //     });
  //   }
  // };
  render() {
    const {
      heading,
      tableData,
      IQCIO_chart_data_new,
      IQCIO_chart_options_new,
    } = this.state;

    const {
      yourTable,
      yourChartOptions,
      yourDrilldown,
      // iqcioChartOptions,
      // iqcioDrilldown,
      // iqcioTable,
    } = this.props;

    return (
      <div className="current_buySell">
        <div className="portlet-body portlet light bordered">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              {yourDrilldown && yourDrilldown.length > 0 ? (
                <Fragment>
                  <h4 className="text-uppercase bold text-center">
                    ORIGINAL PORTFOLIO
                  </h4>
                  <DrillDown
                    chartData={yourDrilldown}
                    chartOptions={yourChartOptions}
                    id="chart1"
                    width={650}
                    height={350}
                    idInner="chart1_inner"
                    defaultDrillView={true}
                  />
                </Fragment>
              ) : null}
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              {IQCIO_chart_data_new && IQCIO_chart_data_new.length > 0 ? (
                <Fragment>
                  <h4 className="text-uppercase bold text-center">
                    IQCIO PORTFOLIO
                  </h4>
                  <DrillDown
                    chartData={IQCIO_chart_data_new}
                    chartOptions={IQCIO_chart_options_new}
                    id="chart2"
                    width={650}
                    height={350}
                    idInner="chart2_inner"
                    defaultDrillView={true}
                  />
                </Fragment>
              ) : null}
            </div>
          </div>
        </div>
        <div className="portlet-body portlet light bordered">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              {tableData && tableData.length > 0 ? (
                <BuySellTable heading={heading} tableData={tableData} />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({
    create: {
      steps: {
        universeLite: {
          analyze_compare: {
            yourTable,
            yourChartOptions,
            yourDrilldown,
            iqcioChartOptions,
            iqcioDrilldown,
            iqcioTable,
          },
        },
      },
    },
  }) => ({
    yourTable,
    yourChartOptions,
    yourDrilldown,
    iqcioChartOptions,
    iqcioDrilldown,
    iqcioTable,
  }),
  null
)(CurrentBuySell);



// WEBPACK FOOTER //
// ./src/components/pages/Current_buy_sell.jsx